import ProfileItemList from './ProfileitemList'
import ProfileItemEdit from './ProfileItemEdit'

const profileItems = {
  list: ProfileItemList,
  edit: ProfileItemEdit,
}

export default profileItems
